import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getDeadline(): number {
  try {
    const stored = localStorage.getItem('ct_deadline');
    if (stored) {
      const parsed = parseInt(stored, 10);
      if (parsed > Date.now()) return parsed;
    }
  } catch {}
  const deadline = Date.now() + DURATION_MS;
  try {
    localStorage.setItem('ct_deadline', String(deadline));
  } catch {}
  return deadline;
}
interface CountdownTimerProps {
  compact?: boolean;
}
export function CountdownTimer({
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const deadline = getDeadline();
    const tick = () => {
      const diff = Math.max(0, deadline - Date.now());
      setTimeLeft({
        hours: Math.floor(diff / 3600000),
        minutes: Math.floor(diff % 3600000 / 60000),
        seconds: Math.floor(diff % 60000 / 1000)
      });
    };
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  if (compact) {
    return <span className="font-mono font-bold text-sm" data-id="element-64">
        {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
      </span>;
  }
  return <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-65">
      <ClockIcon className="w-5 h-5 md:w-6 md:h-6 text-brand-pink-600" data-id="element-66" />
      <div className="flex gap-1 md:gap-2 items-center" data-id="element-67">
        {[{
        val: timeLeft.hours,
        label: 'hs'
      }, {
        val: timeLeft.minutes,
        label: 'min'
      }, {
        val: timeLeft.seconds,
        label: 'seg'
      }].map((item, i) => <React.Fragment key={i} data-id="element-68">
            <div className="flex flex-col items-center" data-id="element-69">
              <div className="bg-gray-900 text-white px-2 md:px-3 py-1 md:py-2 rounded font-mono font-bold text-lg md:text-2xl min-w-[2.5rem] text-center" data-id="element-70">
                {pad(item.val)}
              </div>
              <span className="text-[10px] text-gray-500 mt-0.5" data-id="element-71">{item.label}</span>
            </div>
            {i < 2 && <span className="text-xl md:text-3xl font-bold mb-4" data-id="element-72">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}